import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
// import { createBrowserHistory } from "history";

// const history = createBrowserHistory();

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
});

// API request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const session = localStorage.getItem("session");
    config.headers.Authorization = "Bearer " + token;
    return config;
  },
  (error) => {
    // Handle request error here
    return Promise.reject(error);
  },
);

// API response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error?.response?.data?.sessionExpired ||
      error?.response?.data?.message.includes("Unauthenticated") ||
      error?.response?.data?.message.includes("Not Logged")
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("sessionCount");
      window.location.replace("/login");
      return;
    } else {
      const status = error?.response?.status;
      const statusText = error?.response?.statusText;
      // Handle response error here
      return Promise.reject({
        response: error?.response?.data,
        status,
        statusText,
      });
    }
  },
);

export default axiosClient;
